import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import queryString from 'query-string'
import { connect } from 'react-redux'
import { Spin } from 'antd'
import { act_login, act_logout, act_sso } from '../../redux/actions'
import storageUtils from '../../utils/storageUtils'
import memoryUtils from '../../utils/memoryUtils'

import './sso.css'
/*
SSO的路由組件
*/
class Sso extends Component {
    state = {
        loading: false,
    }

    UNSAFE_componentWillMount() {
        storageUtils.removeUser()
        memoryUtils.user = {}

        const parsed = queryString.parse(window.location.search)
        const { uid, sys } = parsed
        this.setState({loading: true})
        if (uid && sys) {
            this.props.act_sso(uid, sys)
        }
    }

    render() {
        const user = this.props.user
        if (user && user.token) {
            return <Redirect to='/home' />
        } else {
            return (
                <div className="sso"> 
                   <Spin size="large" spinning={this.state.loading} />
                </div>
            )
        }
    }
}

export default connect(
    state => ({ user: state.user }),
    { act_login, act_logout, act_sso }
)(Sso)